import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme/contract.css';

/** 나라별 진행 칩 (퀘스트 7ca8908c) — 섭외 IA §3-3. 조건 줄 맨 앞에 선다(퀘스트 2f546c56). */
export const bar = style({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: vars.spacing.gap.md,
});

export const list = style({
  display: 'flex',
  flexWrap: 'wrap',
  gap: vars.spacing.gap.sm,
  margin: 0,
  padding: 0,
  listStyle: 'none',
});

const chipBase = style({
  display: 'flex',
  alignItems: 'baseline',
  gap: vars.spacing.gap.sm,
  whiteSpace: 'nowrap',
  padding: `${vars.spacing.padding.xs} ${vars.spacing.padding.sm}`,
  borderRadius: vars.spacing.borderRadius.md,
  border: `1px solid ${vars.surface.border.subtle}`,
  background: vars.surface.card.default,
  cursor: 'pointer',
  font: 'inherit',
  selectors: {
    '&:hover': { background: vars.surface.card.hover },
  },
});

export const chip = chipBase;

/** 지금 보고 있는 나라 — 누르는 것이 곧 작업 대상을 바꾸는 일이라 눌린 상태가 분명해야 한다. */
export const chipCurrent = style([
  chipBase,
  {
    borderColor: vars.bright.status.info,
    background: vars.surface.card.active,
  },
]);

export const country = style({
  fontSize: vars.typography.fontSize.sm,
  fontWeight: String(vars.typography.fontWeight.semibold),
  color: vars.typography.textColor.primary,
});

export const detail = style({
  fontSize: vars.typography.fontSize['2xs'],
  color: vars.typography.textColor.tertiary,
});

/** 나라가 하나뿐일 때 — 고를 게 없어 버튼이 아니지만, 지금 나라라는 것은 같은 모양으로 말한다. */
export const fixed = style([
  chipBase,
  {
    margin: 0,
    cursor: 'default',
    borderColor: vars.bright.status.info,
    background: vars.surface.card.active,
    selectors: { '&:hover': { background: vars.surface.card.active } },
  },
]);
